export default "__VITE_PUBLIC_ASSET__8900c60d__"